import { render, staticRenderFns } from "./add-project.vue?vue&type=template&id=433dc400&scoped=true"
import script from "./add-project.vue?vue&type=script&lang=js"
export * from "./add-project.vue?vue&type=script&lang=js"
import style0 from "./add-project.vue?vue&type=style&index=0&id=433dc400&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433dc400",
  null
  
)

export default component.exports